import { useApi } from "~/composables/useApi";
import type {
  CreditInsurerRequestListParams,
  CreditInsurerRequestListResponse,
  CreditInsurerRequestResponse,
} from "@asap/shared/schemas/credit-insurance";

export const useCreditInsurerRequest = () => {
  const { invoke } = useApi();

  const selectPageByCompany = async (
    companyId: string,
    query: CreditInsurerRequestListParams
  ): Promise<CreditInsurerRequestListResponse> => {
    const response = await invoke({
      path: "companies/:companyId/credit-insurer-requests",
      method: "GET",
      params: { companyId },
      query,
    });

    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  };

  const selectAllByCompany = async (companyId: string): Promise<CreditInsurerRequestResponse[]> => {
    const { items } = await selectPageByCompany(companyId, {});
    return items;
  };

  const checkState = async (id: string): Promise<CreditInsurerRequestResponse> => {
    const response = await invoke({
      path: "credit-insurer-request/:id/check",
      method: "POST",
      params: { id },
    });

    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  };

  const requestCover = async (companyId: string, amount: number): Promise<CreditInsurerRequestResponse> => {
    const response = await invoke({
      path: "companies/:companyId/credit-insurer-request",
      method: "POST",
      params: { companyId },
      body: { amount },
    });

    if (!response.success) {
      throw new Error(response.error.message);
    }

    return response.data;
  };

  return { selectAllByCompany, selectPageByCompany, checkState, requestCover };
};
